import { Button, Theme, Typography, withStyles } from '@material-ui/core';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import { FontFamilyByCurrentApp, PrimaryMainBackgroundColorByCurrentApp } from '../../utils/get-app-env';

export const CustomDialogTitle = withStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      justifyContent: 'center',
      width: 545,
      textAlign: 'center',
  
    },
  
  }))(MuiDialogTitle);
  
  export const CustomDialogContent = withStyles((theme: Theme) => ({
    root: {
      padding: theme.spacing(2),
      textAlign: 'center',
  
    },
  }))(MuiDialogContent);
  
  export const TypographyDialogTitle = withStyles((theme: Theme) => ({
    root: {
      fontSize: 18,
      fontWeight: 500,
      color: '#7F7F7F'
    },
  }))(Typography);
  
  export const TypographyDialogContent = withStyles((theme: Theme) => ({
    root: {
      fontSize: 15,
      fontWeight: 500,
      color: '#7F7F7F'
    },
  }))(Typography);
  
  export const DialogActions = withStyles((theme: Theme) => ({
    root: {
      margin: 15,
      padding: theme.spacing(1),
      display: 'flex',
      justifyContent: 'center',
    }
  }))(MuiDialogActions);
  
  
  export const ButtonOutlined = withStyles((theme: Theme) => ({
    root: {
      borderRadius: 8,
      border: 'solid 1px #E94E1B',
      fontFamily: FontFamilyByCurrentApp(),
      color: '#E94E1B',
      
    },
    
  }))(Button);
  
  export const ButtonContained = withStyles((theme: Theme) => ({
    root: {
      borderRadius: 8,
      border: 'solid 1px ' + PrimaryMainBackgroundColorByCurrentApp(),
      fontFamily: FontFamilyByCurrentApp(),
      color: '#FFF',
      backgroundColor: PrimaryMainBackgroundColorByCurrentApp(),
      '&:hover': {
        backgroundColor: PrimaryMainBackgroundColorByCurrentApp(),
        border: 'solid 1px ' + PrimaryMainBackgroundColorByCurrentApp(),
      }
    },
    
  }))(Button);